import type { IReportStoragePort } from '@reports/application/ports';
import type { BlockDataRequestDto } from '@reports/application/dtos';

export const getAppliedFiltersUseCase = (storagePort: IReportStoragePort) => {
  const execute = async (): Promise<BlockDataRequestDto | null> => {
    const filters = await storagePort.getAppliedFilters();

    return filters;
  };

  return { execute };
};
